export class EmailConstants {
    static readonly INBOX = 'Inbox';
    static readonly COMPLETED = 'COMPLETED';

    static readonly EMAIL_SENT_STATUS_SUCCESS = 'SUCCESS';

    static readonly ATTACH_LOCAL_FILE = 'Attach Local File';
    static readonly ATTACH_COMMUNITY_DOC = 'Attach Community Document';
    static readonly ATTACH_OWNER_DOC = 'Attach Owner Document';
    static readonly ATTACH_EMAIL_DOC = 'Attachments from Email';
    static readonly REATTACH_PREVIOUS_EMAIL_ATTACHEMETNS = 'Reattach Previous Email Attachments';

    static readonly QUICK_RESPONSE = 'Quick Response';
    static readonly DOMAIN_CATEGORY = 'Domain - Category';
    static readonly RESOLUTION = 'Resolution';

    static readonly REPLY = 'REPLY';
    static readonly REPLY_ALL = 'REPLYALL';
    static readonly FORWARD = 'FORWARD';
    static readonly NEW = 'NEW';
    static readonly BOARD_MEMBER = 'BOARDMEMBER';

    static readonly USER = 'USER';
    static readonly DEPARTMENT = 'DEPARTMENT';
    static readonly CORP = 'CORP';

    static readonly NA = 'N/A';
    static readonly NAV = 'NA';
    static readonly NONE = 'None';
    static readonly NOT_SELECTED = 'Not Selected';

    static readonly ATTR_PROPERTY = 'Property';
    static readonly ATTR_COMMUNITY = 'Community';
    static readonly ATTR_DOMAIN_CATEGORY = 'DomainCategory';
    static readonly ATTR_ISSUE_RESOLUTION = 'IssueResolution';

    static readonly EMAIL_READ_TIMEOUT = 2500;

    // 60% => windowSize = 0.6
    static readonly WINDOW_SIZE_PERCENT = 0.8;

    // 100% => windowSize = 1
    static readonly MAX_WINDOW_SIZE = 1;
    // 10% => windowSize = 0.1
    static readonly MIN_WINDOW_SIZE = 0.1;

    static readonly CIRAMAIL = 'CIRAMAIL';
    static readonly COMMUNICATION_LOGS = 'COMMUNICATION_LOGS';
    static readonly OWNER_COMMUNICATION = 'OWNER_COMMUNICATION';
}
